export default __webpack_public_path__ + "static/media/messageAnsweredIcon.d3fc2200.svg";